var preventDisconnectWarning = false;

class TopQuizSocket {
  constructor(settings, randomstring) {
    this.settings = settings;
    /**
     * Collection of command based event handlers (callbacks)
     * To attach a callback, add it to this collection with the command key
     * For example: this.on("playerJoined", callback);
     */
    this._commandCallbacks = {};
    // only for debug output
    this._randomNumericId = Math.floor(Math.random() * 999999);
    this.log("New socket created: " + this._randomNumericId);
    this._firstTimeOpen = true;
    this._callWhenOpen = [];
    this._sessionCallbacksGood = {};
    this._sessionCallbacksBad = {};
    this.randomstring = randomstring;
    this.UserRole = 0;

    this.on(
      "topquiz.js",
      "session_success",
      params => {
        var requestCode = params[0];
        var userRole = params[1];
        this._setUserRole(userRole);

        if (requestCode) {
          this._runStashedCommands(requestCode, this._sessionCallbacksGood);
        }
      },
      true
    );

    this.on(
      "topquiz.js",
      "session_error",
      params => {
        var requestCode = params[1];
        var userRole = params[2];
        this._setUserRole(userRole);

        if (requestCode) {
          this._runStashedCommands(requestCode, this._sessionCallbacksBad);
        }
      },
      true
    );
  }

  _setUserRole(userRole) {
    if (!isNaN(userRole)) {
      var changed = userRole != this.UserRole;
      this.UserRole = userRole;
      if (changed) {
        this.onCommand("tq_userRoleChanged", [userRole]);
      }
    }
  }

  _runStashedCommands(requestCode, callbacks) {
    var callback = callbacks[requestCode];
    if (this._isFunction(callback)) {
      callback();
    }
    delete callbacks[requestCode];
  }

  log(message) {
    if (this.settings["verbose"]) {
      console.log(message);
    }
  }

  unsubscribe(owner) {
    var ownerID = owner;
    if (owner._tq_instanceIdentifier) {
      ownerID = owner._tq_instanceIdentifier;
    }

    Object.keys(this._commandCallbacks).forEach(key => {
      var list = this._commandCallbacks[key];
      delete list[ownerID];
    });
  }

  /**
   * Used to add to the collection of command based event handlers (callbacks)
   * To attach a callback, call this function with the command key as the first parameter
   * and the callback as the second one.
   * For example: topquiz.on("topquiz.js", "playerJoined", callback);
   */
  on(owner, command, callback, disableWarning = false) {
    var ownerID = owner;
    if (!owner._tq_instanceIdentifier && typeof owner !== "string") {
      owner._tq_instanceIdentifier = this.randomstring({ length: 20 });
      ownerID = owner._tq_instanceIdentifier;
    } else if (owner._tq_instanceIdentifier) {
      ownerID = owner._tq_instanceIdentifier;
    }

    if (!this._commandCallbacks[command]) {
      this._commandCallbacks[command] = {};
    }

    if (!this._commandCallbacks[command][ownerID]) {
      this._commandCallbacks[command][ownerID] = [];
    }

    if (command.startsWith("session_") && !disableWarning) {
      console.error(
        "Subscribing to session events is not recommended. Use topquiz onSessionEvent instead."
      );
    }

    this._commandCallbacks[command][ownerID] = callback;
  }

  _defaultOptions() {
    return {
      forceCallback: false,
      requiredRole: 0
    };
  }

  _isFunction(functionToCheck) {
    return (
      functionToCheck &&
      {}.toString.call(functionToCheck) === "[object Function]"
    );
  }

  /**
   * use once connected to either trigger this.onSessionCheckSuccess or this.onSessionCheckFailed
   * this sends your stored session key to the server to verify it
   * once verified you can use this.SessionKey to retrieve it
   * when you call this.connect() or this.connect(true) this will be automatically done, to turn it off, pass false
   */
  checkSession(options, callbackGood, callbackBad) {
    // allow checkSession(callbackGood)
    if (this._isFunction(options)) {
      callbackBad = callbackGood;
      callbackGood = options;
      options = this._defaultOptions();
    }

    var requestCode = this.randomstring({ length: 20 });
    this.SessionKey = localStorage.getItem("session_key");

    this.sendCommand(
      "session",
      this.SessionKey,
      options.requiredRole,
      requestCode
    );

    if (this._isFunction(callbackGood)) {
      this._sessionCallbacksGood[requestCode] = callbackGood;
    }

    if (this._isFunction(callbackBad)) {
      this._sessionCallbacksBad[requestCode] = callbackBad;
    }
  }

  _ensureConnected(callback) {
    if (this.ws && this.ws.readyState == WebSocket.OPEN) {
      callback();
      return;
    }

    this._callWhenOpen.push(callback);

    if (this.ws && this.ws.readyState != WebSocket.CONNECTING) {
      this.connect();
    }
  }

  /**
   * Connect to the websocket given in the settings,
   * Attach open/close/error/message handlers to ws
   *
   * To handle the events attach a function to:
   * this.onWsOpen / this.onWsClose / this.onWsError
   */
  connect() {
    var url =
      this.settings["protocol"] +
      "://" +
      this.settings["host"] +
      ":" +
      this.settings["port"];
    this.log("Connecting to: " + url);
    var connection = new WebSocket(url, ["soap", "xmpp"]);
    this.ws = connection;

    connection.onopen = () => {
      this.log("WebSocket opened: " + this._randomNumericId);

      // call on open if first time
      if (this.onWsOpen != undefined && this._firstTimeOpen) {
        this._firstTimeOpen = false;
        this.onWsOpen();
      }

      if (this._callWhenOpen.length > 0) {
        var callback = () => {
          this._callWhenOpen.forEach(cb => {
            cb();
          });

          this._callWhenOpen = [];
        };

        this.checkSession(callback, callback);
      }
    };

    connection.onclose = () => {
      this.log("WebSocket closed: " + this._randomNumericId);
      if (this.onWsClose != undefined) {
        this.onWsClose();
      }

      setTimeout(() => {
        this.onCommand("disconnect", {});
      }, 2000);

      if (!preventDisconnectWarning) {
        // setTimeout(() => {
        // 	$("#__topquiz_connectionLostModal").modal();
        // }, 1000);
      }
    };

    // Log errors
    connection.onerror = error => {
      this.log("WebSocket error: " + error);
      if (this.onWsError != undefined) {
        this.onWsError();
      }
    };

    // Log messages from the server
    connection.onmessage = e => {
      this.onMessageReceived(e.data);
    };
  }

  disconnect() {
    this.ws.onmessage = undefined;
    this.ws.close();
  }

  /**
   * Called when the websocket receives a message from the server
   * Parses the message and calls the appropriate callback if it exists
   */
  onMessageReceived(message) {
    this.log(" <- " + message);
    var json = JSON.parse(message);
    this.onCommand(json.action, json.param);
  }

  /**
   * Calls a command callback if it exists
   * (see this.on() )
   */
  onCommand(command, params) {
    var callbackCollection = this._commandCallbacks[command];
    if (callbackCollection != undefined) {
      Object.keys(callbackCollection).forEach(key => {
        var callback = callbackCollection[key];
        if (callback) {
          callback(params);
        }
      });
    }
  }

  /**
   * Sends a simple command to the server
   */
  sendCommand(commandKey) {
    this._ensureConnected(() => {
      var args = Array.prototype.slice.call(arguments, 1);
      var cmd = JSON.stringify({ action: commandKey, param: args });
      this.ws.send(cmd);
      this.log(" -> " + cmd);
    });
  }

  disableDisconnectWarning() {
    preventDisconnectWarning = true;
  }

  getSpectateLinkFromCode(code) {
    var root =
      window.location.protocol +
      "//" +
      window.location.hostname +
      this.settings["web_root"];
    var link = root + "/spectate/" + code;
    return link;
  }

  getJoinLinkFromCode(code) {
    var root =
      window.location.protocol +
      "//" +
      window.location.hostname +
      this.settings["web_root"];
    var link = root + "/join/" + code;
    return link;
  }
}

module.exports = TopQuizSocket;
